import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import '../../core/enums/GameSpecificTypes.js';
import '../../core/enums/MaxPayoutDataTypes.js';
import '../../core/enums/Chat.js';
import '../../core/enums/GameModes.js';
import '../../core/enums/IconTypes.js';
import '../../core/enums/BetStatus.js';
import '../../core/enums/PopupTypes.js';
import '../../core/enums/ApiVersion.js';
import '../../core/enums/RoundStatus.js';
import '../../core/enums/FreeBetsStatus.js';
import '../../core/enums/SocketEvents.js';
import '../../core/enums/TranslationKeys.js';
import '../../core/enums/TimeoutMaxValue.js';
import '../../core/enums/ApiServiceTypes.js';
import '../../core/enums/EnvironmentTypes.js';
import '../../core/enums/DefaultQueryValues.js';
import '../../core/enums/FreeBetWinningType.js';
import '../../core/enums/DefaultQueryParams.js';
import '../../core/enums/BetHistoryFilterTypes.js';
import '../../core/enums/GameThemeTypes.js';
import '../../core/enums/RequestStatus.js';
import '../../core/enums/FetchDefaultPaths.js';
import '../../core/enums/ResponseCodes.js';
import { checkGameIsReplied } from '../../core/enums/BogLineGameConfig.js';
import '../../../_tslib-7a01aab4.js';
import { y as platformMessageStore, N as applicationStore, Q as userSettingsStore, o as betStore } from '../../../validateBalanceOnBet-af4f4a9b.js';
import '../../core/store/chatStore.js';
import '../../core/store/wageringStore.js';
import '../../core/store/roundInfoStore.js';
import '../../core/store/userCountStore.js';
import '../../core/store/gameResultStore.js';
import '../../core/store/resultHashStore.js';
import '../../core/store/userWinBetsStore.js';
import '../../core/store/notificationStore.js';
import '../../core/store/selectedResultInfoStore.js';
import '../../core/store/forCrashGame/inputValidationStore.js';
import '../../core/store/forCrashGame/totalBetStore.js';
import '../../core/store/forCrashGame/resultReportStore.js';
import '../../core/store/forCrashGame/gameStore.js';
import '../../core/services/liveConnection/types.js';
import 'axios';
import '../../core/services/sound/types.js';
import '../../core/services/sound/SoundService.js';
import '../../core/services/sound/defaultSounds.js';
import '../../core/services/api/types.js';
import '../../core/services/ApiServices.js';
import { BOG_LINE_GAME_TYPES } from '../../core/enums/BogLineGameConfigs.js';
import '../../../momentFormat-e9197995.js';
import { callFakeGameSocketHandlersForBogLineTurboGames, callFakeGameSocketHandlersWithRoundFinAndStart, callFakeGameSocketHandlersWithMarketGames, callFakeGameSocketHandlersForCrashGame, callFakeGameSocketHandlersForSeveralTheSameBets } from '../../core/helpers/gameDrawingSupportersFunctions.js';
import '../../core/polyfill.js';
import '../../contexts/TranslationContext.js';
import '../../contexts/StoreContext.js';
import { useTranslation } from '../../hooks/useTranslation.js';
import '../../core/enums/additionalInputValueChangingButtons.js';
import 'mobx';
import '../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../core/helpers/parseQuery.js';
import '../../core/enums/StatisticsSortingTypes.js';
import '../../core/services/api/BaseApiService.js';
import '../../core/helpers/deepCopy.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import '../../core/helpers/formatDate.js';
import '../../core/helpers/isMobile.js';
import '../../core/enums/bogGameNames.js';
import '../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../_commonjsHelpers-17aad09c.js';
import '../../core/helpers/setTranslationValues.js';

var GameLaunchManager = observer(function (_a) {
    var isTurbo = _a.isTurbo; _a.onReconnect; _a.onLostConnection; var GameContainer = _a.GameContainer, SocketConnectionWr = _a.SocketConnectionWr, callbackForRunningGame = _a.callbackForRunningGame, socketEventsHandlerDelays = _a.socketEventsHandlerDelays;
    var isGameLoading = platformMessageStore.isGameLoading, isRepliedGame = platformMessageStore.isRepliedGame, isUsedBogLineComponents = platformMessageStore.isUsedBogLineComponents, gameType = platformMessageStore.bogLineGameTypeData.gameType, isUsedRoundStartAndFinishedLogicAfterCashOut = platformMessageStore.isUsedRoundStartAndFinishedLogicAfterCashOut;
    var isBogLine = applicationStore.isBogLine;
    var gameService = userSettingsStore.gameService;
    var repliedBetData = betStore.repliedBetData;
    // const { connectionError, reconnect, slowConnection } = popupStore;
    // const { gameIsOpen } = applicationStore;
    var t = useTranslation();
    // useEffect(() => {
    //   const currentErrorCode = gameIsOpen
    //     ? BetResponseCode.GameIsOpen
    //     : connectionError
    //     ? BetResponseCode.ConnectionError
    //     : BetResponseCode.Reconnect;
    //
    //   const currentErrorMessage = t(
    //     gameIsOpen
    //       ? TranslationKeys.YourSessionWasInterrupted
    //       : connectionError
    //       ? TranslationKeys.PleaseRefreshPage
    //       : TranslationKeys.Reconnect
    //   );
    //   if (!repliedBetData && (gameIsOpen || connectionError || reconnect || slowConnection)) {
    //     iframeService.sendErrorReceived({
    //       errorCode: currentErrorCode,
    //       errorMessage: currentErrorMessage,
    //     });
    //   }
    // }, [repliedBetData, gameIsOpen, connectionError, reconnect, t]);
    useEffect(function () {
        if (t) {
            applicationStore.setTranslator(t);
        }
    }, [t]);
    useEffect(function () {
        if (isRepliedGame && applicationStore.isAuthDataReceived) {
            betStore.getRepliedBetData();
        }
    }, [applicationStore.isAuthDataReceived, isRepliedGame]);
    useEffect(function () {
        if (repliedBetData) {
            var preventAllEvents = function (event) {
                event.preventDefault();
                event.stopPropagation();
            };
            var rootElement = document.querySelector('.root');
            if (rootElement instanceof HTMLElement) {
                rootElement.style.pointerEvents = 'none';
                rootElement.addEventListener('click', preventAllEvents, true);
                rootElement.addEventListener('mousedown', preventAllEvents, true);
                rootElement.addEventListener('touchstart', preventAllEvents, true);
                rootElement.addEventListener('touchmove', preventAllEvents, true);
                rootElement.addEventListener('touchend', preventAllEvents, true);
            }
            if (repliedBetData && !isGameLoading) {
                if (isBogLine) {
                    if (callbackForRunningGame) {
                        callbackForRunningGame(repliedBetData);
                    }
                    else {
                        if (isTurbo && !isUsedRoundStartAndFinishedLogicAfterCashOut) {
                            callFakeGameSocketHandlersForBogLineTurboGames({
                                betData: repliedBetData,
                                handleLiveBetsResult: gameService.handleLiveBetsResult.bind(gameService),
                                handleDoBetResult: gameService.handleDoBetResult.bind(gameService),
                                socketEventsHandlerDelays: socketEventsHandlerDelays,
                            });
                        }
                        else if (isUsedRoundStartAndFinishedLogicAfterCashOut) {
                            var betStep = repliedBetData.additionalParams.betStep;
                            callFakeGameSocketHandlersWithRoundFinAndStart({
                                betData: repliedBetData,
                                finishedResultReportData: repliedBetData === null || repliedBetData === void 0 ? void 0 : repliedBetData.roundData.slice(betStep),
                                handleResultReport: gameService.handleResultReport.bind(gameService),
                                handleDoBetResult: gameService.handleDoBetResult.bind(gameService),
                                handleCashOut: gameService.handleCashOutResult.bind(gameService),
                                handleRoundFin: gameService.handleRoundFin.bind(gameService),
                                socketEventsHandlerDelays: socketEventsHandlerDelays,
                            });
                        }
                        else if (gameType === BOG_LINE_GAME_TYPES.ONLY_MARKET) {
                            callFakeGameSocketHandlersWithMarketGames({
                                betData: repliedBetData,
                                handleBetsClosed: gameService.handleBetsClosed.bind(gameService),
                                handleDoBetResult: gameService.handleDoBetResult.bind(gameService),
                                handleRoundFin: gameService.handleRoundFin.bind(gameService),
                                socketEventsHandlerDelays: socketEventsHandlerDelays,
                            });
                        }
                        else if ([BOG_LINE_GAME_TYPES.ONLY_CRASH, BOG_LINE_GAME_TYPES.MARKET_AND_CRASH].includes(gameType) &&
                            !isUsedRoundStartAndFinishedLogicAfterCashOut &&
                            isUsedBogLineComponents) {
                            callFakeGameSocketHandlersForCrashGame({
                                betData: repliedBetData,
                                gameType: platformMessageStore.bogLineGameTypeData.gameType,
                                handleBetsClosed: gameService.handleBetsClosed.bind(gameService),
                                handleRoundStart: gameService.handleRoundStart.bind(gameService),
                                handleResultReport: gameService.handleResultReport.bind(gameService),
                                handleDoBetResult: gameService.handleDoBetResult.bind(gameService),
                                handleCashOutResult: gameService.handleCashOutResult.bind(gameService),
                                handleRoundFin: gameService.handleRoundFin.bind(gameService),
                                socketEventsHandlerDelays: socketEventsHandlerDelays,
                            });
                        }
                        else if (!isUsedBogLineComponents &&
                            !isUsedRoundStartAndFinishedLogicAfterCashOut &&
                            gameType === BOG_LINE_GAME_TYPES.ONLY_CRASH) {
                            callFakeGameSocketHandlersForSeveralTheSameBets({
                                betData: repliedBetData,
                                handleBetsClosed: gameService.handleBetsClosed.bind(gameService),
                                handleRoundStart: gameService.handleRoundStart.bind(gameService),
                                handleResultReport: gameService.handleResultReport.bind(gameService),
                                handleDoBetResult: gameService.handleDoBetResult.bind(gameService),
                                handleCashOutResult: gameService.handleCashOutResult.bind(gameService),
                                handleRoundFin: gameService.handleRoundFin.bind(gameService),
                                socketEventsHandlerDelays: socketEventsHandlerDelays,
                            });
                        }
                    }
                }
                else {
                    callbackForRunningGame && callbackForRunningGame(repliedBetData);
                }
            }
        }
    }, [
        gameType,
        isGameLoading,
        repliedBetData,
        isUsedBogLineComponents,
        isUsedRoundStartAndFinishedLogicAfterCashOut,
    ]);
    // useCheckOnlineStatus({
    //   onReconnect,
    //   onLostConnection,
    //   socketRecursiveReconnecting: gameService?.socketRecursiveReconnecting.bind(gameService),
    // });
    return checkGameIsReplied(window.location.pathname) ? GameContainer : SocketConnectionWr;
});

export { GameLaunchManager };
